import classNames from 'classnames';
import { memo } from 'react';
import styles from './server/elements/Table.module.css';
import ServerHeaderDataCell from './server/HeaderDataCell';
import type { ColumnField } from './server/types';
import { useField } from './utils/TableStore';
import { useColumnWidths } from './utils/TableStore/ResizeContext';
import WithResize from './WithResize';
const DataCellWithResize = WithResize(ServerHeaderDataCell);
function HeaderDataCell<T extends Record<string, unknown>>({
  field,
  firstRow,
  colIndex,
  fixed
}: {
  field: ColumnField<T>;
  firstRow: boolean;
  colIndex: number;
  fixed?: boolean;
}) {
  const column = useField<T>(field)!;
  const widths = useColumnWidths(colIndex);
  return <DataCellWithResize {...column} {...widths} colIndex={colIndex} firstRow={firstRow} className={classNames({
    [styles.fixed!]: fixed
  })} />;
}
export default memo(HeaderDataCell);